import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const eConsentPlatformSlice = createSlice({
    name: 'eConsentPlatform',
    initialState: {
        isConsentAccepted: false,
    },
    reducers: {
        setConsentState: (state, action: PayloadAction<boolean>) => {
            state.isConsentAccepted = action.payload;
        },
    },
});

export const { setConsentState } = eConsentPlatformSlice.actions;
export default eConsentPlatformSlice.reducer;
